import React, {FC} from "react"
import {Route} from "react-router-dom"

import {NestedRoute, PartialRoute} from "@irati/utils/history/routing"
import AppContainer from "@irati/ui/src/AppContainer"
import {LangLoader} from "@irati/utils/lang"
import {PERKS} from "@irati-web/app/src/routeConfig"

import CultureHub from "../containers/CultureHub"

interface Props {
  path: string
}

const CultureHubRoutes: FC<Props> = ({path}) => (
  <LangLoader buckets={[PERKS]}>
    <Route
      path={path}
      render={() => (
        <AppContainer>
          <NestedRoute match={path} exact path="/" component={CultureHub} title="Culture Hub" />
          <PartialRoute useGrid match={path} exact path="/:id" component={CultureHub} title="Culture Hub Tile" />
        </AppContainer>
      )}
    />
  </LangLoader>
)

export default CultureHubRoutes
